import * as React from "react";
import { ODataParams, Query } from '../../Components/Query';
import { useSecurityContext } from "../../Core/SecurityContext";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";
import { GlobalAuthorization } from "../../misc/components/Authorization";
import DocumentTitle from "../../misc/components/DocumentTitle";
import { AccessRequestList } from "./AccessRequestList";

export const AccessRequestListScreen = () => {
    const client = useWebPortalApiClient();
    const { currentUserPermissions } = useSecurityContext();

    const handleRefresh = async (params: ODataParams) => {
        const filter = params.filter ? `(${params.filter})` : undefined;
        return await client.client.getAccessRequests(undefined, filter, params.orderby, undefined, params.top, params.skip, undefined, true);
    }

    return (
        <DocumentTitle title="Requests | Vitalograph Web Portal">
            <GlobalAuthorization currentPermissions={currentUserPermissions} permissionId={PermissionEnum.ViewUserManagement}>
                <Query onRefresh={handleRefresh} initialOrdering={[{ field: "createdAt", condition: "desc" }]}>
                    <AccessRequestList />
                </Query>
            </GlobalAuthorization>
        </DocumentTitle>
    );
}
